export default __webpack_public_path__ + "static/media/img3.04ebf1a0.png";